import axios from 'axios';
import AuthService from './AuthService';

const BASE = process.env.REACT_APP_API_URL;
const hdrs = () => ({ headers: { Authorization: `Bearer ${AuthService.getToken()}` } });
const unwrap = (d) => (Array.isArray(d) ? d : d?.$values ?? []);

const BookingService = {
  getByClientId: (clientId) =>
    axios.get(`${BASE}/Booking/GetByClientId/${clientId}`, hdrs()).then((r) => unwrap(r.data)),

  getByPropertyId: (propertyId) =>
    axios.get(`${BASE}/Booking/GetByPropertyId/${propertyId}`, hdrs()).then((r) => unwrap(r.data)),

  getById: (id) =>
    axios.get(`${BASE}/Booking/GetById/${id}`, hdrs()).then((r) => r.data),

  create: (dto) =>
    axios.post(`${BASE}/Booking/Create`, dto, hdrs()).then((r) => r.data),

  update: (dto) =>
    axios.put(`${BASE}/Booking/Update`, dto, hdrs()).then((r) => r.data),

  updateStatus: (id, status) =>
    axios.put(`${BASE}/Booking/UpdateStatus/${id}`, null, { ...hdrs(), params: { status } }).then((r) => r.data),

  delete: (id) =>
    axios.delete(`${BASE}/Booking/Delete/${id}`, hdrs()).then((r) => r.data),
};

export default BookingService;
